


































import {
	computed, defineComponent, PropType,
} from '@vue/composition-api';
import { Size, Spacing } from '@front-app/components/constants';
import { v4 } from 'uuid';
import TimePickerSection from '@front-app/components/form/TimePickerSection.vue';
import { EventManagementData } from '@front-app/services/EventsApi/EventModel';
import { syncedRef } from '@front-app/util/reactivity';
import { v } from '@front-app/components/form/validation/useValidation';
import { afterDate, required } from '@front-app/components/form/validation/validators';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { getDuration } from '@front-app/util/time';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { toDatetimeLocal, toZonedDatetimeLocal } from '@front-app/util/format';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { useEventAdminStore } from '../../store/EventAdmin';
import EditEventBaseForm from './EditEventBaseForm.vue';

export default defineComponent({
	components: {
		TimePickerSection,
		EditEventBaseForm,
	},
	props: {
		eventData: {
			type: Object as PropType<EventManagementData>,
			required: true,
		},
	},
	setup(props, ctx) {
		const startDate = syncedRef(() => {
			if (props.eventData.startDate) {
				return toDatetimeLocal(props.eventData.startDate);
			}
			return props.eventData.startDate;
		}).ref;
		const endDate = syncedRef(() => {
			if (props.eventData.endDate) {
				return toDatetimeLocal(props.eventData.endDate);
			}
			return props.eventData.endDate;
		}).ref;
		const duration = computed(() => getDuration(ctx, new Date(startDate.value), new Date(endDate.value)));

		// Validation
		const validation = v({
			startDate: {
				value: startDate,
				rules: [required()],
			},
			endDate: {
				value: endDate,
				rules: [afterDate(startDate)],
			},
		});
		const formId = `event-form-${v4()}`;
		const { focusFirstInvalid } = useFocusFirstInvalidField({ containerSelector: `#${formId}` });

		// Submission
		const {
			track,
			isLoading: isSavingUpdates,
			isError: isErrorSavingUpdates,
			isSuccess: isSuccessSavingUpdates,
		} = useAsyncStatus();

		const saveUpdates = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}

			await track(useEventAdminStore().update(props.eventData.id, {
				startDate: toZonedDatetimeLocal(startDate.value) || '',
				endDate: toZonedDatetimeLocal(endDate.value) || '',
			}));

			if (isSuccessSavingUpdates.value) {
				ctx.emit('close');
			}
		};

		return {
			formId,
			startDate,
			endDate,
			duration,
			validation,
			isSavingUpdates,
			isErrorSavingUpdates,
			saveUpdates,
			// Util
			Size,
			Spacing,
			ButtonPalettes,
		};
	},
});
